import { logUrl } from "../Config/Url";
import axios from "axios";

export const logService = {
  get,
};

async function get({
  provisionTypeId,
  level,
  dateFrom,
  dateTo,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
}) {
  return axios
    .put(`${logUrl}/search`, {
      provisionTypeId,
      level,
      dateFrom,
      dateTo,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}
